<template>
    <div>
        <PageSpinner :onloader="onloader" />
        <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/dashboard" class="text-white pl-3">
                Dashboard
            </router-link>
            <router-link to="/school/student-information-system" class="text-white">
                <i class="fa fa-ellipsis-v px-2"></i>Student Information System
            </router-link>
            <span><i class="fa fa-ellipsis-v px-2"></i>Student Graduation</span>
        </base-header>

        <!--Charts-->
        <div class="container-fluid mt--7">
            <div class="mb-5 mb-xl-0">
                <card header-classes="bg-transparent">
                    <modal :show.sync="modals.alumniModal" modal-classes="modal-dialog-centered">
                        <div class="card border-0 mb-0">
                            <div class="card-body">
                                <PageSpinner :onloader="onloader" />
                                <div class="form-horizontal">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Class</label>
                                                <select v-model="ClassIdval" class="form-control"
                                                    @change="GetSchoolOptions()">
                                                     <option value="0" v-if="!classitems">⏳ Loading...</option>
                                                    <option value="0" v-else>-- Select Class --</option>
                                                    <option v-for="item in classitems" :key="item.Id"
                                                        v-bind:value="item.Id">
                                                        {{ item.Sch_Class }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Option</label>
                                                <select v-model="OptionIdval" class="form-control"
                                                    @change="GetSchoolSection()">
                                                     <option value="0" v-if="!optionitems">⏳ Loading...</option>
                                                    <option value="0" v-else>-- Select Option --</option>
                                                    <option v-for="item in optionitems" :key="item.Id"
                                                        v-bind:value="item.Id">
                                                        {{ item.ClassOption }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label>Arm</label>
                                                <select v-model="ArmIdval" class="form-control"
                                                    @change="GetStudentBySection()">
                                                    <option value="0" v-if="!armitems">⏳ Loading...</option>
                                                    <option value="0" v-else>-- Select Arm --</option>
                                                    <option v-for="item in armitems" :key="item.Id"
                                                        v-bind:value="item.Id">
                                                        {{ item.SectionName }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="table-responsive promotion-table-wrapper">
                                        <table class="table table-bordered table-dark promotion-table">
                                            <thead>
                                                <tr>
                                                    <th class="select-col">
                                                        <input type="checkbox" v-model="selectAll"
                                                            title="Select all students" />
                                                    </th>
                                                    <th></th>
                                                    <th>Student Name</th>
                                                    <th>Admission Number</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="item in filteredStudents" :key="item.studentId"
                                                    v-bind:value="item.studentId">
                                                    <td data-label="Select" class="select-col">
                                                        <input type="checkbox" :value="item.studentId"
                                                            v-model="selectedStudents" />
                                                    </td>
                                                    <td data-label="Photo">
                                                        <img v-if="item.passport" :src="item.passport" class="rounded"
                                                            alt="" height="50" />
                                                        <img v-else src="img/brand/loguser.png" class="rounded" alt=""
                                                            height="50" />
                                                    </td>
                                                    <td data-label="Student Name">{{ item.studentName }}</td>
                                                    <td data-label="Admission Number">{{ item.admNo }}</td>
                                                </tr>
                                                <tr v-if="filteredStudents.length === 0">
                                                    <td colspan="4" class="text-center">No students found</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer text-right">
                            <base-button type="default" @click="modals.alumniModal = false">Cancel
                            </base-button>
                            <button type="button" class="btn btn-success" :disabled="selectedStudents.length === 0"
                                v-on:click="GraduateSelectedStudents">
                                Graduate Selected ({{ selectedStudents.length }})
                            </button>
                        </div>
                    </modal>
                    <div class="justify-content-end form-inline my-3">
                        <select v-model="SessionIdval" class="form-control" :disabled="!Sessionitems"
                            @change="GetSchoolStudentAlumnis()">                            
                            <option value="0" v-if="!Sessionitems">⏳ Loading...</option>
                            <template v-else>
                                <option value="0">-- Select Session --</option>
                                <option v-for="item in Sessionitems" :key="item.schoolSessionId"
                                    v-bind:value="item.schoolSessionId">
                                    {{ item.schoolSessionName }}
                                </option>
                            </template>
                        </select>
                        <button v-if="SessionIdval" type="button" @click.prevent="OpenNewForm" class="btn btn-default">
                            <i class="fa fa-plus"></i>Add New
                        </button>
                        <base-input v-if="SessionIdval" class="input-group-alternative" placeholder="Search here..."
                            addon-left-icon="fa fa-search" v-model="searchval">
                        </base-input>
                    </div>
                    <div v-if="alumnis" class="table-responsive mt-2">
                        <table class="table table-bordered table-striped table-hover alumni-table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>Admission Number</th>
                                    <th>Student Name</th>
                                    <th>GraduatedSession</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in alumnis" :key="item.studentId">
                                    <td data-label="Photo">
                                        <img v-if="item.passport" :src="item.passport" class="rounded" alt=""
                                            height="50" />
                                        <img v-else src="img/brand/loguser.png" class="rounded" alt="" height="50" />
                                    </td>
                                    <td data-label="Admission Number">{{ item.admNo }}</td>
                                    <td data-label="Student Name">{{ item.studentName }}</td>
                                    <td data-label="Graduated Session">{{ item.graduatedSession }}</td>
                                    <td data-label="Action"> <button class="btn btn-secondary btn-sm"
                                            v-on:click="ReversestudentGraduation(item.studentId)"><i
                                                class="fa fa-backward"></i> Revert</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </card>
            </div>

            <!-- End charts-->
        </div>
    </div>
</template>

<script>
import moment from "moment";
import Alert from "@/mixins/Alert.mixins"
import PageSpinner from "@/components/PageSpinner";
import CheckStaffUser from "@/mixins/CheckStaffUser.mixin";
export default {
    name: "AlumniManagement",
    mixins: [CheckStaffUser, Alert],
    components: {
        PageSpinner,
    },
    data() {
        return {
            accessDetails: null,
            dataid: 1,
            SessionIdval: 0,
            ClassIdval: 0,
            OptionIdval: 0,
            ArmIdval: 0,
            StudIdval: 0,
            Sessionitems: null,
            termitems: null,
            classitems: null,
            optionitems: null,
            armitems: null,
            studentitems: null,
            selectedStudents: [],
            alumnis: null,
            searchval: "",
            process: "N",
            onloader: "none",
            modals: {
                alumniModal: false
            }
        };
    },
    computed: {
        filteredStudents() {
            if (!this.studentitems) return [];
            if (!this.searchval) return this.studentitems;
            let search = this.searchval.toLowerCase();
            return this.studentitems.filter(
                (item) =>
                    (item.studentName && item.studentName.toLowerCase().includes(search)) ||
                    (item.admNo && String(item.admNo).toLowerCase().includes(search))
            );
        },
        selectAll: {
            get() {
                return (
                    this.filteredStudents.length > 0 &&
                    this.filteredStudents.every((item) =>
                        this.selectedStudents.includes(item.studentId)
                    )
                );
            },
            set(val) {
                this.selectedStudents = val
                    ? this.filteredStudents.map((item) => item.studentId)
                    : [];
            },
        },
    },
    methods: {
        OpenNewForm() {
            this.ClassIdval = 0;
            this.OptionIdval = 0;
            this.ArmIdval = 0;
            this.modals.alumniModal = true;
            this.process = "N";
            this.inputdisable = false;
        },
        GraduateSelectedStudents() {
            let StudIds = this.selectedStudents;
            if (StudIds.length === 0) {
                this.ShowAlertWarning('Please select at least one student to graduate', '');
                return;
            }
            let studentIds = StudIds;
            let graduatedSessionId = this.SessionIdval;
            let userdata = {
                studentIds,
                graduatedSessionId
            };
            this.onloader = "flex";
            this.$store
                .dispatch("PortalStudent/GraduateStudents", userdata)
                .then((resp) => {
                    if (resp.responseCode == "00") {
                        this.selectedStudents = [];
                        this.GetSchoolStudentAlumnis();
                        this.GetStudentBySection();
                        this.onloader = "none";
                        this.ShowAlertSuccess('Submitted Successfully', '');
                    } else {
                        this.onloader = "none";
                        this.ShowAlertError('Submission failed, try again', '');
                    }
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        ReversestudentGraduation(StudentId) {
            this.onloader = "flex";
            this.$store
                .dispatch("ReversestudentGraduation", StudentId)
                .then(() => {
                    this.GetSchoolStudentAlumnis();
                    this.onloader = "none";
                    this.ShowAlertSuccess('Reverted Successfully', '');
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetSchoolStudentAlumnis() {
            let GraduatedSessionId = this.SessionIdval;
            if (!this.Sessionitems) {
                return;
            }
            if (GraduatedSessionId <= 0) {
                this.ShowAlertError('Please select a valid session', '');
                return;
            }
            this.onloader = "flex";
            this.$store
                .dispatch("PortalStudent/GetSchoolStudentAlumnis", GraduatedSessionId)
                .then((resp) => {
                    this.alumnis = resp.data;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetSessions() {           
            this.Sessionitems = null;
            this.SessionIdval = 0;
            this.onloader = "flex";
            this.$store
                .dispatch("PortalSchoolSessionTerm/PortalGetSessionInAlumni")
                .then((resp) => {
                    this.Sessionitems = resp.data;
                    this.onloader = "none";
                })
                .catch((err) => {
                    console.log(err);
                    this.onloader = "none";
                });
        },
        GetSchoolClasses() {
            this.classitems = null;
            this.studentitems = null;
            this.optionitems = null;
            this.armitems = null;
            this.ClassIdval = 0;
            this.onloader = "flex";
            this.$store
                .dispatch("getclass")
                .then((resp) => {
                    this.classitems = resp;
                    this.onloader = "none";
                })
                .catch((err) => {
                    this.onloader = "none";
                    this.ShowAlertError(err.response.data, '');
                });
        },
        GetSchoolOptions() {
            this.studentitems = null;
            this.optionitems = null;
            this.armitems = null;
            this.OptionIdval = 0;
            this.onloader = "flex";
            let ClassId = this.ClassIdval;
            if (ClassId > 0) {
                this.$store
                    .dispatch("getoption", ClassId)
                    .then((resp) => {
                        this.optionitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        GetSchoolSection() {
            this.studentitems = null;
            this.armitems = null;
            this.ArmIdval = 0;
            this.onloader = "flex";
            let OptionId = this.OptionIdval;
            if (OptionId > 0) {
                this.$store
                    .dispatch("getarm", OptionId)
                    .then((resp) => {                        
                        this.armitems = resp;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        GetStudentBySection() {
            this.studentitems = null;          
            let SectionId = this.ArmIdval;
            
            if (SectionId > 0) {               
                this.onloader = "flex";
                this.$store
                    .dispatch("PortalStudent/GetSchoolStudentsBySection", SectionId)
                    .then((resp) => {                       
                        this.studentitems = resp.data;
                        this.onloader = "none";
                    })
                    .catch((err) => {
                        this.onloader = "none";
                        this.ShowAlertError(err.response.data, '');
                    });
            }
        },
        frontEndDateFormat(date) {
            return moment(date).format("YYYY-MM-DD");
        },
        backEndDateFormat(date) {
            return moment(date, "DD/MM/YYYY").format("YYYY-MM-DD");
        },

    },
    mounted() {
        this.accessDetails = this.$store.getters['auth/_user'];
        if (this.accessDetails.isSchoolStaff == false) {
            this.$store.dispatch('auth/Logout')
            this.$router.push('/login')
        } else {
            this.GetSessions();
            this.GetSchoolClasses();
        }


    },
};
</script>


<style scoped>
.select-col {
    width: 45px;
    text-align: center;
}

.select-col input[type="checkbox"] {
    width: 18px;
    height: 18px;
    cursor: pointer;
}

.promotion-table th,
.promotion-table td {
    vertical-align: middle;
}

/* Stack table rows into cards on small screens */
@media (max-width: 767.98px) {
    .promotion-table thead {
        display: none;
    }

    .promotion-table,
    .promotion-table tbody,
    .promotion-table tr,
    .promotion-table td {
        display: block;
        width: 100%;
    }

    .promotion-table tr {
        margin-bottom: 1rem;
        border: 1px solid #1e3e6e;
        border-radius: 0.375rem;
        overflow: hidden;
    }

    .promotion-table td {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        border: none;
        text-align: right;
    }

    .promotion-table td::before {
        content: attr(data-label);
        font-weight: 700;
        text-align: left;
    }

    .promotion-table td.select-col::before {
        margin-right: auto;
    }
}

.alumni-table th,
.alumni-table td {
    vertical-align: middle;
}

/* Stack table rows into cards on small screens */
@media (max-width: 767.98px) {
    .alumni-table thead {
        display: none;
    }

    .alumni-table,
    .alumni-table tbody,
    .alumni-table tr,
    .alumni-table td {
        display: block;
        width: 100%;
    }

    .alumni-table tr {
        margin-bottom: 1rem;
        border: 1px solid #dee2e6;
        border-radius: 0.375rem;
        overflow: hidden;
    }

    .alumni-table td {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 1rem;
        border: none;
        text-align: right;
    }

    .alumni-table td::before {
        content: attr(data-label);
        font-weight: 700;
        text-align: left;
    }
}
</style>
